import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerFormComponent } from './container-form/container-form.component';
import { ContainerListComponent } from './container-list/container-list.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRippleModule } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PipesModule } from 'app/pipes/pipes.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { TranslateModule } from '@ngx-translate/core';
import { AgmCoreModule } from '@agm/core';
import { ContainerService } from 'app/services/container.service';
import { ContainerDeviceListComponent } from './container-device-list/container-device-list.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ContainerLocationFormComponent } from './container-location-form/container-location-form.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ContainerViewComponent } from './container-view/container-view.component';
import { MatCardModule } from '@angular/material/card';
import { ChartsModule } from 'ng2-charts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RouterModule } from '@angular/router';
import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgApexchartsModule } from 'ng-apexcharts';



@NgModule({
  declarations: [ContainerFormComponent,ContainerListComponent, ContainerDeviceListComponent, ContainerLocationFormComponent,ContainerViewComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatSelectModule,
    NgApexchartsModule,
    MatTableModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    MatProgressBarModule,
    MatCardModule,
    MatChipsModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatInputModule,
    MatPaginatorModule,
    RouterModule,
    MatRippleModule,
    NgxMatDatetimePickerModule,
    MatSortModule,
    MatTabsModule,
    ChartsModule,
    NgxChartsModule,
    MatSnackBarModule,
    PipesModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TranslateModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
  })
  ],
  providers: [
    ContainerService
  ]
})
export class ContainerModule { }
